import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getLeaves } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";

export default function LeaveRequests() {
    const [loading, setLoading] = useState(false);
    const [leaves, setLeaves] = useState(null);
    const history = useHistory();
    
    useEffect(() => {
        setLoading(true)
        getLeaves()
            .then((res) => {
                setLeaves(res?.data?.data);
                setLoading(false)
            })
            .catch((err) => {
                console.log(err?.response?.data?.error)
                setLoading(false)
            });
    }, []);

    const navigateById = (path, id) => {
        history.push(`${path}/${id}`);
    };

    return (
        <>
            <div className="spur-card-menu"><Link to="/leave/apply" className="pull-right btn topbtn btn-primary">APPLY FOR LEAVE</Link></div>
            <h1 className="dash-title">Leave Requests</h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Leave Requests</div>
                            
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && leaves && leaves) ? 
                                <div className="table-responsive">
                                    {leaves && leaves.length > 0 ?
                                    <table className="table text-left text-caps table-bordered" id="myTable">
                                        <thead><tr><th>SN</th><th>Employee</th><th>Year</th><th>Leave Type</th><th>Start Date</th><th>End Date</th><th>Days</th>
                                        <th>Status</th><th>Action</th></tr></thead>
                                        <tbody>
                                            {leaves && leaves.map((item, index) => 
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.employee?.first_name} {item.employee?.last_name}</td>
                                                    <td>{item.year}</td>
                                                    <td>{item.leave_type}</td>
                                                    <td>{item.start_date}</td>
                                                    <td>{item.end_date}</td>
                                                    <td>{item.no_of_days || "0"}</td>
                                                    <td><span className={item.status === "draft" ? 'badge badge-primary' : (
                                                        item.status === "submitted" ? 'badge badge-warning' : (
                                                            item.status === "reviewed" ? 'badge badge-success' : (
                                                                item.status === "approved" || item.status === "document" ? 'badge badge-success' : (
                                                                    item.status === "disapproved" ? 'badge badge-danger' : null
                                                                )
                                                            )
                                                        )
                                                    )}>
                                                        {item.status && item.status}</span>
                                                    </td>
                                                    <td>
                                                        <button 
                                                            onClick={() => navigateById("/leave/request", item._id)} 
                                                            className='btn btn-preview'
                                                        >
                                                            <i className="fa fa-eye"></i> View
                                                        </button>
                                                    </td>
                                                </tr> 
                                            )}
                                        </tbody>
                                    </table> : <div className="alert alert-danger myerror d-block">No record found.</div> }
                                </div> : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
